import {
    MultilingualFieldRestDto,
    ProductFilterRestDto,
    ShoppingCartDiscountSchemeRestDto
} from "@/api/pharma-cpc-mgmt/models";
import {ShoppingCartDiscountTypeEnum} from "@/api/enums/shopping-cart-discount-type-enum";
import {StatusEnum} from "@/api/enums/status-enum";
import {ProductFilterRestDtoModel} from "@/models/api/pharma-cpc-mgmt/ProductFilterRestDtoModel";
import {formatDateObjectToDateString} from "@/helpers/functions/date-time";
import {
    MultilingualTextFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/MultilingualTextFieldRestDtoModel";

export class ShoppingCartDiscountSchemeRestDtoModel implements ShoppingCartDiscountSchemeRestDto {
    name: string;
    title?: MultilingualFieldRestDto | null;
    promo_code: string;
    promo_message?: MultilingualFieldRestDto | null;
    minimum_purchase_amount?: number | null;
    is_promo_cumulative_with_discounts ?: boolean | null;
    promo_max_usage?: number | null;
    promo_max_usage_per_user ?: number | null;
    type_code: ShoppingCartDiscountTypeEnum;
    discount_value?: number | null;
    client_group_code?: string | null;
    exclude_prescription_required: boolean;
    product_filter?: ProductFilterRestDto | null;
    begin_date: string;
    end_date?: string | null;
    status_code: StatusEnum;

    constructor(
        name: string,
        title: MultilingualFieldRestDto | null,
        promo_code: string,
        promo_message: MultilingualFieldRestDto | null,
        is_promo_cumulative_with_discounts: boolean | null,
        type_code: ShoppingCartDiscountTypeEnum,
        exclude_prescription_required: boolean,
        product_filter: ProductFilterRestDto | null,
        begin_date: string,
        status_code: StatusEnum
    ) {
        this.name = name;
        this.title = title;
        this.promo_code = promo_code;
        this.promo_message = promo_message;
        this.minimum_purchase_amount = null;
        this.is_promo_cumulative_with_discounts = is_promo_cumulative_with_discounts;
        this.promo_max_usage = null;
        this.promo_max_usage_per_user = null;
        this.type_code = type_code;
        this.discount_value = null;
        this.client_group_code = null;
        this.exclude_prescription_required = exclude_prescription_required;
        this.product_filter = product_filter;
        this.begin_date = begin_date;
        this.end_date = null;
        this.status_code = status_code;
    }

    static createWithDefaults(): ShoppingCartDiscountSchemeRestDtoModel {
        return new ShoppingCartDiscountSchemeRestDtoModel(
            '',
            MultilingualTextFieldRestDtoModel.createWithDefaults(),
            '',
            MultilingualTextFieldRestDtoModel.createWithDefaults(),
            false,
            ShoppingCartDiscountTypeEnum.PERCENTAGE_FOR_SHOPPING_CART_PART,
            false,
            ProductFilterRestDtoModel.createWithDefaults(),
            formatDateObjectToDateString(new Date()),
            StatusEnum.NOT_PUBLISHED
        );
    }
}
